var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import DEFAULT_COMPONENT_ICON from '../../assets/defaultComponentIcon.png';
import UcCompSource from "../../CompSource";
import FloatPortal from '../Portal/FloatPortal';
import ComponentDemo, { DEMO_PADDING, DEMO_FOOTER_HEIGHT } from './component-demo';
import "./component-button.css";
import { INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
// 鼠标悬停超过这个时间才会展示demo
const DEMO_DELAY_TIME = 200;
const DEMO_MAX_HEIGHT = 300;
let ComponentButton = class ComponentButton extends Vue {
  constructor() {
    super(...arguments);
    // 是否展示demo
    this.visible = false;
  }
  get demo() {
    try {
      if (!this.designer.displayComponentDemo) return null;
      if (!this.item.demo) return null;
      const demo = JSON.parse(this.item.demo);
      // 检查demo的信息是否齐全
      const validateDemo = demo => {
        if (demo.src && demo.info) {
          return true;
        }
        return false;
      };
      if (!validateDemo(demo)) {
        return null;
      }
      return demo;
    } catch (error) {
      return null;
    }
  }
  get onApplyResult() {
    // 来自于preset的onApply
    if (this.item.onApply) {
      return {
        scene: 'material',
        onApply: this.item.onApply
      };
    }
    return undefined;
  }
  render() {
    const h = arguments[0];
    return h(UcCompSource, {
      "key": this.item.id,
      "attrs": {
        "value": this.item.layout,
        "display": this.item.display || 'block',
        "title": this.item.name,
        "fitDataResult": this.onApplyResult
      },
      "class": "ucd-listWithCatalogue-defaultItem ucd-materialBox-materialItem",
      "on": {
        "closeDemoPopover": this.handleCloseDemoPopover
      },
      "nativeOn": {
        "mouseenter": this.handleMouseenter,
        "mouseleave": this.handleMouseleave
      }
    }, [this.demo && h(FloatPortal, [this.visible && this.renderDemo()]), h("img", {
      "attrs": {
        "src": this.item.icon || DEFAULT_COMPONENT_ICON
      },
      "class": "ucd-listWithCatalogue-defaultItem-icon"
    }), h("div", {
      "class": "ucd-listWithCatalogue-defaultItem-title"
    }, [this.item.name])]);
  }
  renderDemo() {
    const h = this.$createElement;
    return h("transition", {
      "attrs": {
        "name": "uc-component-demo"
      }
    }, [h(ComponentDemo, {
      "attrs": {
        "demoStyle": this.getDemoStyle(),
        "demo": this.demo,
        "componentId": this.item.layout.type
      },
      "on": {
        "demoMouseEnter": this.keepDemoVisible,
        "demoMouseLeave": this.handleMouseleave
      }
    }), ";"]);
  }
  getDemoStyle() {
    const styles = this.getDemoWidthAndHeight();
    const {
      height,
      maxHeight,
      maxWidth,
      width
    } = styles;
    const picHeight = Math.min(height, maxHeight);
    const {
      offset
    } = this.getAlign(picHeight);
    const [left, top] = offset;
    return {
      top: `${top}px`,
      left: `${left}px`,
      height: `${height}px`,
      width: `${width}px`,
      maxHeight: `${maxHeight}px`,
      maxWidth: `${maxWidth}px`
    };
  }
  handleCloseDemoPopover() {
    this.closeDemo();
  }
  handleMouseenter() {
    this.timer = setTimeout(() => {
      this.visible = true;
    }, DEMO_DELAY_TIME);
  }
  keepDemoVisible() {
    clearTimeout(this.closeDemoTimer);
    if (this.visible) return;
    this.handleMouseenter();
  }
  handleMouseleave() {
    this.closeDemoTimer = setTimeout(() => {
      this.closeDemo();
    }, 100);
  }
  closeDemo() {
    clearTimeout(this.timer);
    clearTimeout(this.closeDemoTimer);
    this.visible = false;
  }
  getAlign(picHeight) {
    const {
      bottom: elBottom,
      width,
      height,
      top: elTop
    } = this.$el.getBoundingClientRect();
    const sidePaneElement = document.querySelector('.ucd-asidePane');
    if (!sidePaneElement) {
      return {
        offset: [0, 0]
      };
    }
    // demo和组件图标保持5个像素的距离
    const gap = 5;
    const left = width + gap;
    let top = height + gap;
    // 当组件的图标很靠近面板的底部时，需要将组件的demo上移
    const buffer = 20; // 留一个20px的缓冲，避免图片的边缘贴着浏览器的底部
    const bottom = window.innerHeight - elBottom - gap - buffer; // 计算从组件的上边缘到面板的底部的距离
    const footerHight = this.designer.$scopedSlots.componentDemoLink ? DEMO_FOOTER_HEIGHT : 0; // 底部的高度
    // 计算展示demo需要的高度
    // 分别是： 图片高度 + 间距 + 底部高度 + 图片的padding + 跑马灯组件额外增加的高度(5.5px)
    const demoHeight = picHeight + gap + footerHight + DEMO_PADDING * 2 + 5.5;
    // 如果无法往右下方放
    if (demoHeight > bottom) {
      // 如果上方的空间足够，就放在右上方
      if (elTop > demoHeight) {
        top = -demoHeight;
      } else if (bottom + height > demoHeight) {
        // 如果我们能在不超过组件的情况下，在组件的右下方展示，就放在右下方
        top = bottom + height - demoHeight;
      } else if (elTop + height > demoHeight) {
        // 无法放在右下方的话，尝试放在右上方
        top = -demoHeight + height;
      } else {
        // 都不行，还是放在右上方，保证底部插槽渲染的组件可以展示
        top = -demoHeight;
      }
    }
    return {
      offset: [left, top]
    };
  }
  getDemoWidthAndHeight() {
    let height;
    let width;
    if (!this.demo.extra) {
      height = this.demo.info.height;
      width = this.demo.info.width;
    } else {
      // 如果有多张图片的话，容器的宽高都要取这些图片中最大的
      height = Math.max(...this.demo.extra.map(item => item.info.height).concat(this.demo.info.height));
      width = Math.max(...this.demo.extra.map(item => item.info.width).concat(this.demo.info.width));
    }
    const maxHeight = Math.min(height / 2, DEMO_MAX_HEIGHT);
    const maxWidth = width * maxHeight / height;
    return {
      height,
      width,
      maxHeight,
      maxWidth
    };
  }
};
ComponentButton = __decorate([Component({
  name: 'ComponentButton',
  components: {
    UcCompSource,
    ComponentDemo
  },
  props: {
    item: Object
  },
  inject: {
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  }
})], ComponentButton);
export default ComponentButton;
//# sourceMappingURL=ComponentButton.js.map
